// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const PinFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 2l.247.004A8 8 0 0120 9.92c0 5.48-7 11.58-7.35 11.84a1 1 0 01-1.3 0l-.022-.019C10.805 21.286 4 15.304 4 9.92A8 8 0 0112 2zm0 4a3.5 3.5 0 100 7l.192-.005A3.5 3.5 0 0015.5 9.5l-.005-.192A3.5 3.5 0 0012 6zm1.06 2.44a1.5 1.5 0 11-2.12 2.12 1.5 1.5 0 012.12-2.12z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export const PinFillOffset: IconOffset = {
    vertical: 8,
    horizontal: 17,
};

export default React.memo(PinFill);
